var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"to-top",on:{"click":_vm.gototop}},[_c('img',{attrs:{"src":require("@/assets/web/20.png"),"alt":"","srcset":""}}),_c('span',[_vm._v("回到顶部")])])}
var staticRenderFns = []

export { render, staticRenderFns }